import {RouterProps} from "../../RouterProps";
import {useStatePair} from "react-type-extension";
import {EnvConstructionValueObject} from "../../../data/value-object/env/EnvConstructionValueObject";
import {EnvConstructionSearchOption} from "../../../data/search-option/env/EnvConstructionSearchOption";
import {SortOrder} from "ts-protocol-extension";
import ListPageWrapper from "../../ListPageWrapper";
import {EnvConstructionIO} from "../../../io/EnvIO";
import {EnvConstructionDescription} from "../../../data/description/env/EnvConstructionDescription";
import {EnvConstructionDescriptor} from "../../../data/descriptor/env/EnvConstructionDescriptor";
import ListOption from "../../ListOption";
import {EnvConstructionSearchOptionDescription} from "../../../data/description/env/EnvConstructionSearchOptionDescription";
import {
    applyEnvConstructionSearchOption,
    EnvConstructionSearchOptionField
} from "../../search-option-field/env/EnvConstructionSearchOptionField";
import ListOrder from "../../ListOrder";
import {SearchIndex} from "../../../io/HttpClient";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<EnvConstructionValueObject[]>([])
    const option = useStatePair<EnvConstructionSearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={EnvConstructionIO}
                items={items}
                option={option.value}
                index={index}
                description={EnvConstructionDescription}
                descriptor={EnvConstructionDescriptor}
                showPost
                onPostClick={() => document.location = '/env/constructions/post'}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/env/constructions/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={EnvConstructionSearchOptionDescription}
                fields={EnvConstructionSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyEnvConstructionSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={EnvConstructionDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}